<dx-popup
    #historyPopup
    width="70%"
    height="75%"
    [title]="title"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="!loadingVisible"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onHistoryPopUpShown()"
    (onHidden)="onHistoryPopUpClose()"
>
    <div id="history" *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="property-container">
                        <dx-box width="100%" height="100%" direction="row">
                            <dxi-item baseSize="auto">
                                <div class="row-container">
                                    <div class="row-label">Community:</div>
                                    <div class="row-value">{{ communityName }}</div>
                                </div>
                            </dxi-item>

                            <dxi-item baseSize="auto">
                                <div class="row-container">
                                    <div class="row-label">{{ payeeLabel }}:</div>
                                    <div class="row-value">{{ payee }}</div>
                                </div>
                            </dxi-item>
                        </dx-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1" [visible]="!hasGridSourceData">
                <div *dxTemplate>
                    <div *ngIf="!hasGridSourceData" class="no-data-container">
                        <span [innerHTML]="noDataText"></span>
                    </div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1" [visible]="hasGridSourceData">
                <div *dxTemplate>
                    <cc-data-grid-features
                        #gridFeatures
                        [stateConfig]="{ storageKey: 'IVA_HISTORY' }"
                        [dataSource]="gridSource"
                    >
                        <dx-data-grid appHasInternalUserColumns width="100%" height="100%" [dataSource]="gridSource">
                            <dxo-selection mode="single"></dxo-selection>

                            <dxi-column
                                dataField="workflowId"
                                caption="Workflow Id"
                                dataType="number"
                                [width]="60"
                            ></dxi-column>
                            <dxi-column
                                caption="Invoice"
                                alignment="center"
                                cellTemplate="invoiceFileCellTemplate"
                                [width]="50"
                            ></dxi-column>
                            <dxi-column
                                dataField="invoiceNumber"
                                caption="Invoice Number"
                                dataType="string"
                            ></dxi-column>
                            <dxi-column
                                dataField="invoiceDate"
                                caption="Invoice Date"
                                dataType="date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="invoiceAmount"
                                caption="Invoice Amount"
                                dataType="number"
                                [format]="currencyFormat"
                                [width]="60"
                            ></dxi-column>
                            <dxi-column
                                dataField="status"
                                caption="Status"
                                dataType="string"
                                cellTemplate="statusCellTemplate"
                                [width]="50"
                            ></dxi-column>
                            <dxi-column
                                caption="Payment Cleared"
                                alignment="center"
                                cellTemplate="paymentClearedTemplate"
                                [width]="60"
                            ></dxi-column>
                            <dxi-column
                                name="InternalNotes"
                                dataField="hasNotes"
                                alignment="center"
                                caption="Notes"
                                dataType="boolean"
                                cellTemplate="notesCellTemplate"
                                [width]="50"
                            ></dxi-column>
                            <dxi-column
                                name="InternalLogs"
                                caption="History"
                                alignment="center"
                                cellTemplate="historyCellTemplate"
                                [width]="50"
                            ></dxi-column>
                            <dxi-column
                                dataField="isEFT"
                                caption="EFT"
                                dataType="boolean"
                                alignment="center"
                                cellTemplate="eftCellTemplate"
                                [width]="50"
                            ></dxi-column>
                            <dxi-column
                                dataField="paymentDate"
                                caption="Payment Date"
                                dataType="date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="paymentNumber"
                                caption="Payment Number"
                                dataType="string"
                                [width]="60"
                            ></dxi-column>
                            <dxi-column
                                dataField="amountToPay"
                                caption="Amount To Pay"
                                dataType="number"
                                [format]="currencyFormat"
                                [width]="60"
                            ></dxi-column>
                            <dxi-column dataField="handling" caption="Handling" dataType="string"></dxi-column>
                            <dxi-column
                                caption="Vendor Account Number"
                                dataField="vendorAccountNumber"
                                dataType="string"
                            ></dxi-column>

                            <div *dxTemplate="let a of 'historyCellTemplate'">
                                <i
                                    class="cc-1-5x icon-data-content dx-theme-accent-as-text-color"
                                    [ngClass]="iconHistory"
                                    (click)="onWorkflowHistoryClick(a.data)"
                                ></i>
                            </div>

                            <div *dxTemplate="let a of 'statusCellTemplate'">
                                <app-hyperlink-creator
                                    *ngIf="isPaymentCleared(a.data)"
                                    [displayText]="a.data.status"
                                    (onLinkClick)="onPaymentHistoryClick(a.data)"
                                ></app-hyperlink-creator>
                                <div *ngIf="!isPaymentCleared(a.data)" class="status-content">
                                    {{ a.data.status }}
                                </div>
                            </div>

                            <div *dxTemplate="let d of 'invoiceFileCellTemplate'">
                                <i
                                    class="cc-1-5x icon-data-content cc-icon-pdf"
                                    [ngClass]="iconPDF"
                                    (click)="onDownloadFile(d.data)"
                                ></i>
                            </div>

                            <div *dxTemplate="let d of 'eftCellTemplate'">
                                <div *ngIf="d.data.isEFT">
                                    <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
                                </div>
                            </div>

                            <div *dxTemplate="let d of 'paymentClearedTemplate'">
                                <div *ngIf="d.data.paymentCleared">
                                    <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
                                </div>
                            </div>

                            <div *dxTemplate="let d of 'notesCellTemplate'">
                                <div *ngIf="d.data.hasNotes">
                                    <i
                                        class="cc-1-5x icon-data-content cc-icon-check"
                                        [ngClass]="iconNotes"
                                        (click)="onNotesClick(d.data)"
                                    ></i>
                                </div>

                                <div *ngIf="!d.data.hasNotes">
                                    <i
                                        class="cc-1-5x icon-data-content dx-theme-accent-as-text-color"
                                        [ngClass]="iconEmptyNotes"
                                    ></i>
                                </div>
                            </div>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>

            <dxi-item baseSize="auto">
                <div *dxTemplate class="button-container">
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconCancel"
                                    (onClick)="onHistoryPopUpClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-workflow-notes-viewer
    *ngIf="showNotesPopup"
    [visible]="showNotesPopup"
    [workflowId]="selectedRecord.workflowId"
    [communityId]="communityId"
    (closeNotesPopUp)="onHistoryNotesPopClose()"
></app-workflow-notes-viewer>

<app-workflow-history
    *ngIf="showWorkflowHistory"
    [workflowId]="selectedHistoryRecord.workflowId"
    [communityId]="communityId"
    (onClose)="onWorkflowHistoryClose()"
></app-workflow-history>

<app-workflow-payment-history
    *ngIf="showPaymentHistory"
    [workflowId]="selectedHistoryRecord.workflowId"
    [communityId]="communityId"
    [managementCompanyId]="managementCompanyId"
    (onClose)="onPaymentHistoryClose()"
></app-workflow-payment-history>

<dx-load-panel
    [position]="{ of: '#history' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
